import styled from 'styled-components';

export const Container = styled.div`
  min-width: 720px;
  gap: 10px;
  padding: 1rem;
`;

export const Wrapper = styled.div`
  margin-bottom: 0.8rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #c2cfd6;
  width: 100%;
`;

export const Header = styled.div`
  padding: 0.7rem 1.3rem;
  background-color: transparent;
  border-bottom: 1px solid #c2cfd6;

  strong {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
  }
`;

interface StyledTdProps {
  depth: number;
}

export const Td = styled.td<StyledTdProps>`
  text-overflow: ellipsis;
  overflow: hidden;
  background-color: ${(props) => (props.depth === 0 ? '#F4F4F4' : 'initial')};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 2rem;
  margin-bottom: 40px;

  table {
    font-size: 1rem;
    border: 1px solid rgb(238, 238, 238);
    overflow-y: scroll;

    tr {
      padding-bottom: 0.5px;

      :hover {
        background-color: rgba(98, 47, 255, 0.08);
      }
    }

    th,
    td {
      padding: 5px;
      text-align: start;
    }

    thead {
      position: relative;
      font-weight: 700;
      background-color: white;

      th {
        text-align: center;
        border-bottom: 1px solid rgb(238, 238, 238);
        line-height: normal;
      }
    }

    tbody {
      position: relative;
      z-index: 0;
      height: 655px;
      display: block;
      overflow: scroll;

      td {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
`;

export const FlexBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
